import "./style.css"

export default function WatchCoursesLoader() {
    const dummyArray = Array.from({ length: 5 }, (_, i) => i);
    return (
        // <div className="courseMain1 rounded-[7px] grid max-[600px]:grid-cols-2 max-[1200px]:grid-cols-3 grid-cols-4 bg-[#f8f8f8] max-[1200px]:bg-white watchCoursesLoaderMain">

        <div className="courseMain1 rounded-[7px] grid max-[600px]:grid-cols-2 max-[1200px]:grid-cols-3 grid-cols-4 watchCoursesLoaderMain">

            {dummyArray.map((item, index) => (
                <div key={index}>
                    {/* Image Placeholder */}
                    <div className="max-[500px]:h-[220px] h-36 rounded-lg watchCoursesLoaderMain_com2"></div>

                    <div className='px-[10px] py-[13px] rounded-bl-[10px] rounded-br-[10px] border-b border-l border-r -mt-1 !border-[#e5e5e5] watchCoursesLoaderMain_2'>
                        {/* Title Placeholder */}
                        <div className="h-5 rounded watchCoursesLoaderMain_com"></div>

                        <hr className='mt-[8px] mb-[8px]' />

                        {/* Enrollment Info */}
                        <div className='flex items-center'>
                            <div className="w-[20px] h-[20px] mr-[5px] rounded-full watchCoursesLoaderMain_com"></div>
                            <div className="h-4 w-[70%] rounded watchCoursesLoaderMain_com"></div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
